import { reactive, toRefs } from 'vue'

import type { ProcessedImage } from '@/components/propertyDetails/queries/types'

export interface UploadingImage {
  id: string
  status: 'UPLOADING'
  name: string
}

const state = reactive({
  isSettingMainImage: false,
  isUploading: false,
  selectedImageIds: [] as string[],
  deleteItemIds: [] as string[],
  uploadingImages: [] as UploadingImage[],
})

export function usePropertyImages() {
  const setIsSettingMainImage = (isSettingMainImage: boolean) => {
    state.isSettingMainImage = isSettingMainImage
  }

  const setDeleteItemIds = (imageIds: string[]) => {
    state.deleteItemIds = imageIds
  }

  const resetDeleteItemIds = () => {
    state.deleteItemIds = []
  }

  const selectImage = (imageId: string) => {
    const imageIndex = state.selectedImageIds.indexOf(imageId)
    const currentSelectedImages = [...state.selectedImageIds]
    if (imageIndex >= 0) {
      currentSelectedImages.splice(imageIndex, 1)
      state.selectedImageIds = currentSelectedImages
    } else {
      state.selectedImageIds = [...state.selectedImageIds, imageId]
    }
  }

  const selectAll = (checked: boolean, items: ProcessedImage[]) => {
    const allIds: string[] = []
    items.forEach(item => {
      if (item.customProperties.isDeletable && !item.isMainImage) {
        allIds.push(item.imageId)
      }
    })
    state.selectedImageIds = checked ? allIds : []
  }

  const resetSelectedIds = () => {
    state.selectedImageIds = []
  }

  const setUploading = (uploading: boolean) => {
    state.isUploading = uploading
  }

  const setUploadingImages = (item: UploadingImage) => {
    const currentUpload = state.uploadingImages.length > 0 ? [...state.uploadingImages] : []
    currentUpload.push(item)
    state.uploadingImages = currentUpload
  }

  const removeUploadingImages = () => {
    state.uploadingImages = []
  }

  return {
    ...toRefs(state),
    setIsSettingMainImage,
    setDeleteItemIds,
    resetDeleteItemIds,
    selectImage,
    selectAll,
    resetSelectedIds,
    setUploading,
    setUploadingImages,
    removeUploadingImages,
  }
}
